module.exports = __webpack_public_path__ + "12f750dcd3d4af4ff3dcbc3ae20346a5.svg";